import Button from '../Button/Button';
import Show from '../Show/Show';
import { FC } from 'react';
import { StyleSheet } from 'react-native';
import { View } from 'react-native';
import { observer } from 'mobx-react';
import { useStores } from '../../hooks/useStores';

interface SessionButtonsProps {
  onNext: () => void;
  /**
   * overlay (default): absolutely positioned at the bottom of the scrolling
   * content. footer: rendered in the frame's fixed footer slot, always on
   * screen — the height stays reserved so the content doesn't jump when the
   * button appears, except on an activity step still waiting for the user's
   * choice, whose own CTAs take that place.
   */
  placement?: 'overlay' | 'footer';
}
const _SessionButtons: FC<SessionButtonsProps> = ({
  onNext,
  placement = 'overlay',
}) => {
  const { language, treeNav } = useStores();
  const labels = language.translate.MOBILE?.SESSION;

  const reserveFooter = !(treeNav.content.stepType === 'ACTIVITY' && !treeNav.canContinue);
  const style = placement === 'footer'
    ? [styles.Footer, reserveFooter && styles.FooterReserved]
    : styles.Container;

  return (
    <View style={style} id="QuestionSessionButtons">
      <Show when={treeNav.isContentReady && treeNav.canContinue}>
        <Button
          label={treeNav.isFinal ? labels?.IN_SESSION_FINISH: labels?.IN_SESSION_CONTINUE} // the problem here is that inFinal does not handle case that depends on the answer
          onPress={onNext}
          height={50}
          marginBottom={0}
        />
      </Show>
    </View>
  );
};

const styles = StyleSheet.create({
  Container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    bottom: 0,
    width: '100%',
  },
  Footer: {
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  FooterReserved: {
    minHeight: 50,
  },
});

export const SessionButtons = observer(_SessionButtons);
